import React from "react";
import { EntityContextInterface } from "module/entity/context/entity/EntityContext";

export type TrainingContextInterface = EntityContextInterface;

const TrainingContext = React.createContext(<TrainingContextInterface>{});

export default TrainingContext;
